import {
  useWSModal,
  WSCard,
  WSEmptyState,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import { IPayerResponse } from "@wingspanhq/payments/dist/interfaces";
import { WSQueryCache } from "@ws-react-query";
import { useEffect } from "react";
import { useQueryInsuranceCoverageMonitor } from "../../../../../query/insuranceCoverageMonitor/queries/useQueryInsuranceCoverageMonitor";
import { useMutationUpdatePayer } from "../../../../../query/payers/mutations/useMutationUpdatePayer";
import { IPolicyType } from "../../../../../services/api/insurance/coverage/types";
import { REQUIREMENTS_DEPENDENCIES } from "../../../dependencies";

type Props = {
  onClose: () => void;
  payer: IPayerResponse;
  policyTypes: IPolicyType[];
  insuranceCoverageMonitorId: string;
};

const ModalMatchingInProgress: React.FC<Props> = props => {
  const [updatePayer, updatePayerMeta] = useMutationUpdatePayer({
    dependencies: REQUIREMENTS_DEPENDENCIES
  });

  useQueryInsuranceCoverageMonitor(props.insuranceCoverageMonitorId, {
    enabled: updatePayerMeta.isSuccess,
    refetchInterval: response => {
      if (response?.status && response?.status !== "Pending") {
        // TODO: issue with cache cause monitor status is updating synchronously and requirement status is updating asynchronously
        setTimeout(() => {
          WSQueryCache.invalidateQueries(REQUIREMENTS_DEPENDENCIES);
          props.onClose();

          setTimeout(() => {
            WSQueryCache.invalidateQueries(REQUIREMENTS_DEPENDENCIES);
          }, 3000);
        }, 3000);

        return false;
      }

      return 3000;
    }
  });

  useEffect(() => {
    updatePayer({
      id: props.payer.payerId,
      payeeOwnedData: {
        shareInsurancePolicyTypes: [
          ...(props.payer.payeeOwnedData.shareInsurancePolicyTypes || []),
          ...props.policyTypes
        ] as any
      }
    });
  }, []);

  return (
    <WSList gap="XL">
      <WSCard header="Policy matching">
        <WSList gap="L">
          <WSList gap="M">
            <WSInfoBox
              theme="neutral"
              icon="loader"
              transparent
              iconColor="blue400"
            >
              Please wait while we check your resources for matching policies...
            </WSInfoBox>

            <WSEmptyState
              bgColor="gray"
              title={""}
              orientation="horizontal"
              type="documents"
              size="S"
            />
            <WSInfoBox
              theme="neutral"
              icon="time"
              transparent
              iconColor="gray600"
            >
              Please wait while we check your resources for matching policies...
            </WSInfoBox>
          </WSList>
          <WSInfoBox theme="neutral">
            Do not close the pop-up while we checking your resources. If you
            close and exit out before any matches are found you can restart the
            process again.
          </WSInfoBox>
        </WSList>
      </WSCard>
    </WSList>
  );
};

export const useModalMatchingInProgress = () =>
  useWSModal(ModalMatchingInProgress, {
    title: "Policy matching",
    size: "M"
  });
